export class AuthModel {
  token: string;
  refreshToken: string;
  expiresAt: Date;
  impersonateToken: AuthModel | null;

  setAuth(auth: AuthModel) {
    this.token = auth.token;
    this.refreshToken = auth.refreshToken;
    this.expiresAt = new Date(auth.expiresAt);
    if(auth.impersonateToken) {
      this.impersonateToken = new AuthModel();
      this.impersonateToken.setAuth(auth.impersonateToken);
    }
  }

  isExpired() {
    return this.expiresAt < new Date();
  }
}
